
<mat-checkbox [(ngModel)]="checked" (ngModelChange)="onModelChange($event)" [disabled]="readonly" [labelPosition]="textBefore ? 'before' : null">{{title$ | async}}</mat-checkbox>
